import { useState, useEffect } from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark, faAngleLeft, faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import Select from "react-select";
import { useUser } from "../utils/UserContext";
import { toast } from 'react-hot-toast';

function Account({accountBar, toggleAccountBar }) {
    const { user } = useUser();
    const [loading, setLoading] = useState(false);
    const [disable, setDisable] = useState(true);
    const currencyoptions = [
        { value: "USD", label: "USD (US Dollar)" },
        { value: "EUR", label: "EUR (Euro)" },
        { value: "GBP", label: "GBP (British Pound)" },
        { value: "AUD", label: "AUD (Australian Dollar)" },
        { value: "CAD", label: "CAD (Canadian Dollar)" },
        { value: "CHF", label: "CHF (Swiss Franc)" },
        { value: "CNY", label: "CNY (Chinese Yuan)" },
        { value: "INR", label: "INR (Indian Rupee)" },
        { value: "JPY", label: "JPY (Japanese Yen)" },
        { value: "RUB", label: "RUB (Russian Ruble)" },
        { value: "ZAR", label: "ZAR (South African Rand)" },
    ];
    const [currency, setCurrency] = useState(user?.currency);
    useEffect(() => {
      if(currency){
        setDisable(false);
      }else{
        setDisable(true);
      }
    }, [currency]);
    const darkThemeStyles = {
        control: (styles) => ({
          ...styles,
          backgroundColor: "#151719",
          border: "none",
          color: "#fff",
          minWidth: "135px"
        }),
        menu: (styles) => ({
          ...styles,
          backgroundColor: "#151719",
        }),
        option: (styles, { isFocused, isSelected }) => ({
          ...styles,
          backgroundColor: isSelected ? "rgb(30, 33, 36)" : isFocused ? "rgb(30, 33, 36)" : "#151719",
          color: "#fff",
        }),
        singleValue: (styles) => ({
          ...styles,
          color: "#fff",
        }),
    };
    const ValidateSave = () =>{
      setLoading(true);
      fetch(`${process.env.REACT_APP_API_URL}controller/profile.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ currencyupdate: true, currency: currency })
      })
      .then(response => response.json())
      .then(data => {
        if (data.status === "success") {
          setLoading(false);
          toggleAccountBar();
          toast.success(data.result);
        }else{
          toast.error(data.message);
        }
      })
      .catch(err => {
        console.error(err)
        setLoading(false);
        toast.error('There was an issue processing your deposit.')
      })
    }
    return (
    <div className={`notifybar ${accountBar ? "active" : null}`}>
        <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center" style={{cursor: 'pointer'}}>
                <FontAwesomeIcon icon={faAngleLeft} style={{color: 'white', cursor: 'pointer', fontSize: '14px'}} onClick={() => {toggleAccountBar()}}/>
                <p className="mb-0 fw-semibold ms-3 text-white">Account Settings</p>
            </div> 
            <FontAwesomeIcon icon={faXmark} style={{color: 'gray', cursor: 'pointer', fontSize: '20px'}} onClick={() => {toggleAccountBar()}}/>
        </div>
        <div className="sidebar-navbar" style={{height: 'auto', paddingBottom: '200px'}}>
            <label className="fw-semibold mb-1" style={{fontSize: '14px'}}>Currency:</label>
            <Select 
                options={currencyoptions} 
                value={currencyoptions.find((opt) => opt.value === currency)}
                onChange={(e) => setCurrency(e.value)}
                styles={darkThemeStyles}
                className="w-full"
            />
            <div className={`myBtn w-100 text-center mt-5 ${disable?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={!disable ? ValidateSave : null}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Save'}</div>
        </div>
    </div>
    )
}

export default Account